/*
 * Copyright (c) 2023-2024. Haodong JU
 */

import GlobalSettings from '@/model/global/GlobalSettings'

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import ConsumeType from '@/model/dataLayer/api/buffet/ConsumeType'
import Payment from '@/model/dataLayer/api/common/Payment'
import Servant from '@/model/dataLayer/api/tableAndPerson/Servant'
import PaymentColors from '@/model/dataLayer/api/common/PaymentColors'
import i18n from '@/i18n'
import { forceGetSystemSetting } from '@/model/dataLayer/api/NewSettings'
import IKUtils from 'innerken-js-utils'
import { sortBy } from 'lodash-es'

const entity = {
  paymentArr: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => await Payment.getList(true),
        multiple: true,
        color: PaymentColors.getList(),
        itemText: '_langsname'
      }
    },
    tableConfig: {
      width: '220px'
    },
    displayName: 'PaymentType'
  },
  orderId: {
    type: IKDataEntity.Types.Integer,
    displayName: 'orderNumber', // 订单编号
    tableConfig: {
      align: 'start'
    },
    formConfig: {
      disableNew: true,
      disableEdit: true,
      requiredNew: false
    }
  },
  tableName: {
    displayName: 'tableNumber',
    tableConfig: {
      sortable: true,
      overwrite: true
    }
  },
  servantName: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => await Servant.getList(true),
        itemText: 'name',
        itemValue: 'name'
      }
    },
    displayName: i18n.t('staff'),
    header: false
  },
  consumeTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: ConsumeType.getList,
        itemText: 'localName'
      }
    }
  },
  updateTimestamp: {
    displayName: 'TimeStamp', // 结账时间
    type: IKDataEntity.Types.Date
  },
  totalPrice: {
    displayName: 'cash_amount',
    tableConfig: {
      sortable: true,
      overwrite: true
    }
  },
  outsideCode: {
    displayName: 'QueueNumberBon',
    form: false
  },
  printFrenchBill: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    },
    header: async () => {
      const res = await forceGetSystemSetting({
        section: 'aadenAdmin',
        sKey: 'useFrenchBill',
        sValue: '0',
        defaultValue: '0',
        sType: 'boolean',
        minimumVersion: '1.7.784',
        sOptions: '',
        tagList: 'basic'
      })
      return res !== '0'
    }
  },
  printItalyBill: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    },
    header: async () => {
      const res = await forceGetSystemSetting({
        section: 'aadenAdmin',
        sKey: 'useItalyBill',
        sValue: '0',
        defaultValue: '0',
        sType: 'boolean',
        minimumVersion: '1.7.784',
        sOptions: '',
        tagList: 'basic'
      })
      return res !== '0'
    }
  }

}

const config = {
  load: async function (filter) {
    // const restaurantInfo = await getNiceRestaurantInfo()
    // const useDailySerial = restaurantInfo.useDailySerialAsQueueNumber
    // const fromDailySerial = parseFloat(restaurantInfo.dailySerialDisplayRotationFrom)
    // const toDailySerial = parseFloat(restaurantInfo.dailySerialDisplayRotationTo)
    const timespan = filter[0].dateFilter.join(' - ')
    const list = (await hillo.get('Orders.php', {
      op: 'withSortAndFilter',
      lang: GlobalSettings.getLang(),
      timespan
    }, { timeout: 5 * 60 * 1000 })).content

    list.map(function (item) {
      if (item.payLogs) {
        item.paymentArr = item.payLogs.map(n => parseInt(n.paymentMethodId)).join(',')
      } else {
        item.paymentArr = '0'
      }
      // if (useDailySerial === '1' && (item.tableName.startsWith('W') || item.tableName.startsWith('w'))) {
      //   item.tableName = item.dailySerial ? 'W' + rotateDailySerial(item.dailySerial, fromDailySerial, toDailySerial) : item.tableName
      // }
      if (item.rawAddressInfo) {
        try {
          const decode = JSON.parse(item.rawAddressInfo)
          item.isTakeaway = decode?.metaData?.takeawayWebVersion === 'new'
          if (item.paymentMethodName === 'Stripe') {
            item.outsideCode = decode?.reservationId
          }
        } catch (e) {

        }
      } else {
        item.isTakeaway = false
      }
      item.id = item.orderId
      return item
    })
    const cashbookId = (await ConsumeType.getList(true)).find(it => it.name === 'BBH').id
    return list.filter(it => it.consumeTypeId?.toString() !== cashbookId.toString())
  }
}
export default IKDataEntity.ModelFactory(entity, config)

export async function printFrenchBillController (item) {
  return await hillo.post('FrenchBillController.php?op=addAndPrint', {
    ...item
  })
}
export async function getUUidByOrderId (orderId) {
  return (await hillo.get('Orders.php?op=showOne', {
    id: orderId
  })).content[0]?.electronicUuid ?? ''
}

export async function getOrderDetail (orderId) {
  return (await hillo.get('Orders.php?op=showOne', {
    id: orderId
  })).content[0]
}

export async function sendMailTo (mailTo, uuid) {
  try {
    await hillo.jsonPost('https://sendinvoicemail-evhwqutgjq-ey.a.run.app', {
      mailTo,
      uuid,
      templateId: 'z3m5jgr8xpoldpyo'
    })
  } catch (e) {
    IKUtils.showError(e?.message)
  }
}

export async function isAddAndPrintV2 () {
  return (await hillo.get('FrenchBillController.php?op=isAddAndPrintV2', {}))?.content
}

export async function getAllFrenchBillByOrderId (orderId) {
  const res = (await hillo.get('FrenchBillController.php?op=getFullFrenchBillByOrderId', {
    orderId
  })).content.filter(it => !it.cancellingBillId)
  return sortBy(res, 'id')
}

export async function doReprintFrenchBill (frenchBillId) {
  return await hillo.post('FrenchBillController.php?op=doReprint', {
    frenchBillId
  })
}

export function rotateDailySerial (dailySerialNumber, fromNumber, toNumber) {
  console.log(dailySerialNumber, fromNumber, toNumber)
  const rotateFrom = fromNumber ?? 1
  const rotateTo = toNumber
  if (rotateTo == null || rotateTo < 1) {
    return dailySerialNumber
  } else {
    const rotatedSerial = (parseFloat(dailySerialNumber) - 1) % (rotateTo - rotateFrom + 1)
    console.log(rotatedSerial + rotateFrom)
    return rotatedSerial + rotateFrom
  }
}
